<template>
	<Toast />
	<ul class="list-none p-0 m-0 flex align-items-center font-medium mb-3">
		<li>
			<a class="text-500 no-underline line-height-3 cursor-pointer"
				>Bitacoras</a
			>
		</li>
		<li class="px-2">
			<i class="pi pi-angle-right text-500 line-height-3"></i>
		</li>
		<li>
			<span class="text-900 line-height-3">Listado Bit&aacute;coras</span>
		</li>
	</ul>
	<div class="surface-section px-4 py-5 md:px-6 lg:px-8">
		<div
			class="flex align-items-start flex-column lg:justify-content-between lg:flex-row"
		>
			<div>
				<div class="font-medium text-3xl text-900">Administrar Bit&aacute;coras</div>
				<div class="flex align-items-center text-700 flex-wrap">
					<div class="mr-5 flex align-items-center mt-0">
						<i class="pi pi-briefcase mr-2"></i>
						<span>{{ totalRegistros }} Bit&aacute;coras</span>
					</div>
				</div>
			</div>
			<div class="flex mt-3 lg:mt-0">
				<Button
					label="Exportar Excel"
					class="p-button-outlined mr-2"
					icon="pi pi-file-excel"
					v-tooltip.top="'Descargar bitácoras en formato CSV compatible con Excel'"
					@click="exportarExcel"
				>
				</Button>
			</div>
		</div>
		<div class="mt-4">
			<DataTable
				ref="dtbitacoras"
				dataKey="id"
				:value="bitacoras"
				:paginator="true"
				:loading="cargando"
				:rows="10"
				:rowHover="true"
				class="p-datatable-sm"
				paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
				:rowsPerPageOptions="[5, 10, 25, 50, 100]"
				currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords} Bitacoras"
				exportFilename="bitacoras"
				responsiveLayout="scroll"
			>
				<template #loading>
					<div class="flex align-items-center justify-content-center">
						<ProgressSpinner />
					</div>
				</template>

				<template #empty> No existen Registros</template>

				<Column field="id" header="CÓDIGO" :sortable="true"></Column>
				<Column field="nombre_usuario" header="USUARIO"></Column>
				<Column field="accion" header="ACCION">
					<template #body="{ data }">
						<div class="flex align-items-center gap-2">
							<span class="bitacora-resumen" :title="resumenAccion(data)">
								{{ resumenAccion(data) }}
							</span>
							<Button
								icon="pi pi-eye"
								class="p-button-text p-button-sm"
								v-tooltip.top="'Ver detalle'"
								:aria-label="'Ver detalle de bitácora ' + data.id"
								@click="verDetalle(data)"
							/>
						</div>
					</template>
				</Column>
				<Column field="tabla" header="TABLA"></Column>
				<Column field="campo" header="CAMPO">
					<template #body="{ data }">{{ valorCampo(data) }}</template>
				</Column>
				<Column field="valor_anterior" header="VALOR ANTERIOR">
					<template #body="{ data }">
						<span class="bitacora-valor" :title="valorDetallado(valorAuditoria(data, 'anterior'))">
							{{ valorAuditoria(data, "anterior") }}
						</span>
					</template>
				</Column>
				<Column field="valor_nuevo" header="VALOR NUEVO">
					<template #body="{ data }">
						<span class="bitacora-valor" :title="valorDetallado(valorAuditoria(data, 'nuevo'))">
							{{ valorAuditoria(data, "nuevo") }}
						</span>
					</template>
				</Column>
				<Column field="fecha" header="FECHA REGISTRO">
					<template #body="{ data }">{{ formatoFecha(data.fecha) }}</template>
				</Column>
			</DataTable>
		</div>
		<Dialog
			v-model:visible="detalleVisible"
			:header="'Detalle de bitácora' + (bitacoraSeleccionada ? ' #' + bitacoraSeleccionada.id : '')"
			:modal="true"
			:style="{ width: 'min(700px, 95vw)' }"
		>
			<div v-if="bitacoraSeleccionada" class="grid">
				<div class="col-12 md:col-6">
					<strong>Usuario</strong>
					<div>{{ bitacoraSeleccionada.nombre_usuario || "—" }}</div>
				</div>
				<div class="col-12 md:col-6">
					<strong>Fecha y hora</strong>
					<div>{{ formatoFecha(bitacoraSeleccionada.fecha) }}</div>
				</div>
				<div class="col-12 md:col-6">
					<strong>Tabla</strong>
					<div>{{ bitacoraSeleccionada.tabla || "—" }}</div>
				</div>
				<div class="col-12 md:col-6">
					<strong>Campo modificado</strong>
					<div>{{ valorCampo(bitacoraSeleccionada) }}</div>
				</div>
				<div class="col-12 md:col-6">
					<strong>Valor anterior</strong>
					<pre class="bitacora-detalle">{{ valorDetallado(valorAuditoria(bitacoraSeleccionada, "anterior")) }}</pre>
				</div>
				<div class="col-12 md:col-6">
					<strong>Valor nuevo</strong>
					<pre class="bitacora-detalle">{{ valorDetallado(valorAuditoria(bitacoraSeleccionada, "nuevo")) }}</pre>
				</div>
				<div class="col-12">
					<strong>Acción</strong>
					<p class="mb-2">{{ accionDetallada(bitacoraSeleccionada.accion) }}</p>
					<details v-if="jsonAccion(bitacoraSeleccionada.accion)">
						<summary>Ver datos adicionales</summary>
						<pre class="bitacora-detalle">{{ jsonAccion(bitacoraSeleccionada.accion) }}</pre>
					</details>
				</div>
			</div>
		</Dialog>
	</div>
</template>
<script>
import BitacoraService from "@/service/BitacoraService";

export default {
	data() {
		return {
			bitacoras: [],
			cargando: false,
			totalRegistros: 0,
			detalleVisible: false,
			bitacoraSeleccionada: null,
		};
	},
	bitacoraService: null,

	created() {
		this.bitacoraService = new BitacoraService();
	},

	mounted() {
		this.cargarBitacoras();
	},

	methods: {
		cargarBitacoras() {
			this.cargando = true;
			this.bitacoraService
				.getBitacorasAll()
				.then((data) => {
					this.bitacoras = Array.isArray(data)
						? data
						: Array.isArray(data.bitacoras)
						? data.bitacoras
						: [];
					this.totalRegistros = this.bitacoras.length;
				})
				.catch((error) => {
					this.$toast.add({
						severity: "error",
						summary: "Error",
						detail: error || "No se pudieron cargar las bitácoras.",
						life: 5000,
					});
				})
				.finally(() => {
					this.cargando = false;
				});
		},
		exportarExcel() {
			if (!this.bitacoras.length) {
				this.$toast.add({
					severity: "warn",
					summary: "Sin datos",
					detail: "No hay bitácoras para exportar.",
					life: 3000,
				});
				return;
			}
			this.$refs.dtbitacoras.exportCSV();
		},
		verDetalle(bitacora) {
			this.bitacoraSeleccionada = bitacora;
			this.detalleVisible = true;
		},
		resumenAccion(bitacora) {
			const accion = this.datosAccion(bitacora.accion);
			if (accion && typeof accion === "object") {
				return (
					accion.descripcion ||
					accion.accion ||
					accion.mensaje ||
					`Registro de ${bitacora.tabla || "cambios"}`
				);
			}
			return this.textoAccion(accion) || "—";
		},
		accionDetallada(accion) {
			const datos = this.datosAccion(accion);
			if (datos && typeof datos === "object") {
				return datos.descripcion || datos.accion || datos.mensaje || "Registro de actividad";
			}
			return this.textoAccion(datos) || "—";
		},
		datosAccion(accion) {
			const texto = typeof accion === "string" ? accion : "";
			const parseado = this.parsearJson(accion);
			if (parseado !== texto || typeof accion !== "string") return parseado;

			const inicioJson = texto.indexOf("{");
			if (inicioJson < 0) return texto;
			const json = this.parsearJson(texto.slice(inicioJson));
			return json === texto.slice(inicioJson)
				? texto
				: { descripcion: texto.slice(0, inicioJson).trim(), datos: json };
		},
		jsonAccion(accion) {
			const datos = this.datosAccion(accion);
			if (!datos || typeof datos !== "object") return "";
			const contenido = Object.prototype.hasOwnProperty.call(datos, "datos")
				? datos.datos
				: datos;
			return JSON.stringify(contenido, null, 2);
		},
		textoAccion(accion) {
			return typeof accion === "string" ? accion.trim() : "";
		},
		parsearJson(valor) {
			if (typeof valor !== "string") return valor;
			try {
				return JSON.parse(valor);
			} catch (error) {
				return valor;
			}
		},
		detalleAuditoria(bitacora) {
			const accion = this.datosAccion(bitacora.accion);
			const contenedores = [
				accion,
				accion && accion.datos,
				accion && accion.auditoria,
				accion && accion.cambio,
				accion && accion.detalle,
				accion && accion.changes,
				accion && accion.cambios,
			].filter((valor) => valor && typeof valor === "object");
			const buscar = (claves) => {
				for (const contenedor of contenedores) {
					for (const clave of claves) {
						if (Object.prototype.hasOwnProperty.call(contenedor, clave)) {
							return contenedor[clave];
						}
					}
				}
				return undefined;
			};
			return {
				campo:
					bitacora.campo ??
					bitacora.campo_modificado ??
					bitacora.field ??
					bitacora.atributo ??
					buscar(["campo", "campo_modificado", "field", "atributo", "column"]),
				anterior:
					bitacora.valor_anterior ??
					bitacora.valorAnterior ??
					bitacora.old_value ??
					bitacora.valor_viejo ??
					buscar(["valor_anterior", "valorAnterior", "old_value", "valor_viejo", "anterior"]),
				nuevo:
					bitacora.valor_nuevo ??
					bitacora.valorNuevo ??
					bitacora.new_value ??
					buscar(["valor_nuevo", "valorNuevo", "new_value", "nuevo"]),
			};
		},
		valorCampo(bitacora) {
			const detalle = this.detalleAuditoria(bitacora);
			if (detalle.campo !== undefined && detalle.campo !== null && detalle.campo !== "") {
				return detalle.campo;
			}
			return this.esCambioProducto(bitacora) ? "Sin detalle" : "No aplica";
		},
		valorAuditoria(bitacora, tipo) {
			const valor = this.detalleAuditoria(bitacora)[tipo];
			if (valor !== undefined && valor !== null && valor !== "") {
				return typeof valor === "object" ? JSON.stringify(valor) : valor;
			}
			return this.esCambioProducto(bitacora) ? "Sin detalle" : "No aplica";
		},
		esCambioProducto(bitacora) {
			const tabla = String(bitacora.tabla || "").toLowerCase();
			const campo = this.detalleAuditoria(bitacora).campo;
			return Boolean(campo) || tabla.includes("producto") || tabla.includes("stock");
		},
		valorDetallado(valor) {
			const parseado = this.parsearJson(valor);
			return parseado === null || parseado === undefined || parseado === ""
				? "—"
				: typeof parseado === "object"
				? JSON.stringify(parseado, null, 2)
				: String(parseado);
		},
		formatoFecha(fecha) {
			if (!fecha) return "—";
			const valor = new Date(fecha);
			if (Number.isNaN(valor.getTime())) return fecha;
			return new Intl.DateTimeFormat("es-BO", {
				day: "2-digit",
				month: "2-digit",
				year: "numeric",
				hour: "2-digit",
				minute: "2-digit",
				second: "2-digit",
				hour12: false,
			}).format(valor);
		},
	},
};
</script>
<style scoped>
.bitacora-resumen,
.bitacora-valor {
	display: inline-block;
	max-width: 18rem;
	overflow: hidden;
	text-overflow: ellipsis;
	vertical-align: bottom;
	white-space: nowrap;
}

.bitacora-detalle {
	margin: 0.35rem 0 0;
	max-height: 14rem;
	overflow: auto;
	white-space: pre-wrap;
	word-break: break-word;
}
</style>
